
<!--<div class="spc-users-list-scroll">   
    <div class="spc-users-list">
        <div *ngIf="filteredList?.length === 0 && searchText" class="no-matches">
            No data found.
        </div>
        <div class="spc-user-sec" [ngClass]="{'selected': isSelected(item)}" (click)="userSelect(item)" *ngFor="let item of filteredList; trackBy: trackByUserId">
            <div class="profile-pic">
                <img class="profile-icon" 
                    [src]="item?.gender?.toLowerCase() === 'male' ? '/assets/img/male_pic.png' :
                        item?.gender?.toLowerCase() === 'female' ? '/assets/img/female_pic.png' : 
                        '/assets/img/dp_pic.png'" 
                    alt="Profile Image"/>
            </div>
            <div class="spc-user-txt">
                <span>{{item?.userName}}</span>
                <span class="desc ellipsis-text">{{item?.lastMessage}}</span>
            </div>
            <div class="spc-user-act">
                <span class="active-time">{{ getRelativeTime(item?.lastMessageReceivedAt) }}</span>
                <span class="active-counts" *ngIf="item?.unreadCount !== 0"><span>
                    {{item?.unreadCount }}
                </span></span>
            </div>
        </div>
    </div>
</div>-->
<div class="spc-users-list-scroll">
    <div class="spc-users-list">
        <div *ngIf="filteredList?.length === 0 && searchText" class="no-matches">
            No data found.
        </div>
        
       <cdk-virtual-scroll-viewport
  itemSize="50"
  class="users-viewport"
  (scrolledIndexChange)="onScrollDown($event)">

            <div *cdkVirtualFor="let item of filteredList; trackBy: trackByUserId" 
                class="spc-user-sec" 
                [ngClass]="{'selected': isSelected(item)}" 
                (click)="userSelect(item)">
                
                <div class="profile-pic">
               <img class="profile-icon"
     [src]="item.profilePicUrl 
             || (item?.gender?.toLowerCase() === 'male' ? '/assets/img/male_pic.png' :
                 item?.gender?.toLowerCase() === 'female' ? '/assets/img/female_pic.png' : 
                 '/assets/img/dp_pic.png')"
     alt="Profile Image" />
                        <img *ngIf="item?.isLoggedIn" class="user_list_status" src="/assets/img/icon1.svg" alt="Online" />
                      <img *ngIf="!item?.isLoggedIn" class="user_list_status" src="/assets/img/icon2.svg" alt="Offline" />
                </div>
                
                <div class="spc-user-txt">
                    <span class="title">{{item?.userName}}</span>
                     <span class="desc ellipsis-text">
                     {{ getDisplayMessage(item?.lastMessage) }}
                    </span>
                </div>
                
                <div class="spc-user-act">
                    <span class="active-time">{{ getRelativeTime(item?.lastMessageReceivedAt) }}</span>
                    <span class="active-counts" *ngIf="item?.unreadCount !== 0 && !userDeletedImgage">
                        <span>{{ item?.unreadCount }}</span>
                    </span>
                </div>
                
            </div>
        </cdk-virtual-scroll-viewport>
    </div>
</div>